export enum UserTypes {
  ADMIN = "admin",
  USER = "user",
}
